import React from 'react'
import CreateAdmin from '../createAdmin/Index'

const UpdateAdmin = () => {
  return (
    <CreateAdmin/>
  )
}

export default UpdateAdmin